import { Link } from "react-router";
import React from "react";
import { UnauthenticatedPage } from "Components/Pages/UnauthenticatedPage";
import { observer } from "mobx-react";
import { useStyles } from "./NotFoundPage.styles";

export const NotFoundPageBase = () => {
    const classNames = useStyles();

    return (
        <div className={classNames.root}>
            <UnauthenticatedPage
                content={
                    <div>
                        <h3>Page not found!</h3>
                        <p>
                            You seem to be lost. Can I take you <Link to="/">home</Link>?
                        </p>
                    </div>
                }
            />
        </div>
    );
};

export const NotFoundPage = observer(NotFoundPageBase);
